<template>
  <div class="wscn-http404-container">
    <div v-loading="loading" class="wscn-http404">
      <div v-if="isShow">
        <div class="pic-404">
          <img
            class="pic-404__parent"
            src="../assets/images/404.png"
            alt="404"
          />
        </div>
        <div class="bullshit">
          <div class="bullshit__oops">404错误!</div>
          <div class="bullshit__headline">{{ message }}</div>
          <div class="bullshit__info">对不起，您正在寻找的页面不存在。</div>
          <div class="back">
            <router-link to="/" class="bullshit__return-home">
              返回首页
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  data() {
    return {
      ArticleID: '',
      path: '',
      paths: '',
      isShow: false,
      loading: true,
      timer: null,
    }
  },
  computed: {
    message() {
      return '找不到网页！'
    },
  },
  async created() {
    var ArticleNum = this.$route.query.id
    let data = { ArticleNum }
    const res = await this.$store.dispatch('_GetArticleIDByNum', data)
    if (res.data.IsSuccess) {
      this.loading = false
      this.isShow = false
      this.ArticleID = res.data.Data.ArticleID
      this.timer =
        (() => {
          window.location.href =
            this.Url + '#/digest?ArticleID=' + this.ArticleID
        },
        100)
    } else {
      this.loading = false
      this.isShow = true
    }
  },
  beforeUnmount() {
    this.loading = false
    clearInterval(this.timer)
    this.timer = null
  },
}
</script>

<style scoped></style>
